export class Application {
    public id: number = 0;
    public clientName?: string;
    public clientId?: string;
    public clientUri?: string;
    public commercialName?: string;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    get value(): number {
        return this.id;
    }

    get text(): string {
        return `${this.clientName} ${this.clientUri}`;
    }
}
